
// --
// TWITTER SHARE
// --
// class that shares shareTxt via twiter dialog/web intent
//

// --
// USAGE
// --
//
// data-component="share-twitter" data-component-options='{"shareURL":false,"shareText":"[share text here]"}'
//
// "shareURL" if set to false won't be apeneded to end of share text
// "shareText" is the text that gets shared as a tweet
//


import Component_share_base from './_share-base'

export default class Component_share_twitter extends Component_share_base {

  constructor(el, options) {

    super(el, $.extend(true, {

      'windowTarget':'https://twitter.com/intent/tweet?text=',
      'windowName':'twitter',
      'windowParams':'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0'

    }, options), 'component');

  }

  
  // overload base trigerShare function
  //combine share text with share url if share url isn't false
  
  triggerShare(event){

    this.readLatestElementOptions();

    event.preventDefault();

    var textToShare = this.options.shareText;

    if(this.options.shareURL)
    {
      textToShare = textToShare + " "+this.options.shareURL;
    }

    this.openSharePopup(textToShare,this.options.windowTarget,this.options.windowName,this.options.windowParams);

  }

}




/** WEBPACK FOOTER **
 ** ./components/share-twitter.js
 **/